import { CircularProgress, Container, Grid, Paper, TextField, Typography } from "@mui/material"
import { useState } from "react";
import { PatternFormat } from 'react-number-format';
import Button from "../UI/Button";
import MasterCardImg from '../../shared/assets/img/financeiro/cartao_credito/master-card.png';
import VisaCardImg from '../../shared/assets/img/financeiro/cartao_credito/visa.png';
import HipercardImg from '../../shared/assets/img/financeiro/cartao_credito/hipercard.png';
import { toast } from "react-toastify";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { criarUsuarioCartaoCredito } from "./api-usuario-cartao-credito";
import { successBg, successBorder } from "../UI/ColorUtil";
import { useNavigate } from 'react-router';

const UsuarioCartaoCreditoForm = () => {
    const [criaTokenCartaoCredito, setCriaTokenCartaoCredito] = useState(null);
    const [isLoadingAction, setIsLoadingAction] = useState(false);
    const [finalizadoOk, setFinalizadoOk] = useState(false);
    const history = useNavigate();

    const handleChange = (event) => {
        setCriaTokenCartaoCredito({
            ...criaTokenCartaoCredito,
            [event.target.name]: event.target.value
        })
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        if (criaTokenCartaoCredito.NumeroCartao.length !== 19) {
            errorMessage("Número do Cartão Inválido");
            return;
        }
        if (criaTokenCartaoCredito.DataValidade.length !== 7) {
            errorMessage("Data Validade Inválido");
            return;
        }
        if (criaTokenCartaoCredito.CodigoSeguranca.length !== 3) {
            errorMessage("Código de Segurança Inválido");
            return;
        }
        setIsLoadingAction(true);
        criarUsuarioCartaoCredito(criaTokenCartaoCredito).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    toast.success("Salvo com sucesso.", {
                        position: "bottom-left"
                    });
                    setFinalizadoOk(true);


                }
            }
            setIsLoadingAction(false);
        })
    }

    const handleGoBack = () => {
        history(-1);
    }

    return (
        <Container maxWidth="sm" component={Paper} style={{ marginTop: '30px' }}>
            <Grid container spacing={3} >
                {finalizadoOk ?
                    <>
                        <Grid size={12}>
                            <div style={{
                                paddingLeft: '20px',
                                backgroundColor: successBg,
                                border: '5px',
                                borderStyle: 'solid',
                                borderRadius: '20px',
                                borderColor: successBorder
                            }}>
                                <p style={{ fontWeight: 'bold' }}>Cartão Cadastrado com Sucesso</p>
                                <p>Seu cartão foi cadastrado com sucesso retorne para a página para utiliza-lo</p>

                            </div>
                        </Grid>
                        <Grid size={12}>
                            <Button
                                onClick={handleGoBack}
                            >Voltar</Button>

                        </Grid>


                    </>
                    :
                    <Grid size={12}>
                        <form onSubmit={clickSubmit}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <Typography variant='body1' style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        Cartão de Crédito
                                    </Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Grid container direction='row'>
                                        <Grid size={6}>

                                        </Grid>
                                        <Grid>
                                            <img
                                                style={{
                                                    height: '30px',
                                                    width: '30px',
                                                }}
                                                src={MasterCardImg}
                                                alt=''
                                            />
                                            <img
                                                style={{
                                                    height: '25px',
                                                    width: '30px',
                                                    marginLeft: '10px'
                                                }}
                                                src={VisaCardImg}
                                                alt=''
                                            />
                                            <img
                                                style={{
                                                    height: '25px',
                                                    width: '30px',
                                                    marginLeft: '10px'
                                                }}
                                                src={HipercardImg}
                                                alt=''
                                            />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid size={12}>
                                    <Grid container direction='row'>
                                        <Grid size={6}>
                                            <Typography variant='body1'>
                                                Nome Impresso
                                            </Typography>
                                        </Grid>
                                        <Grid size={6}>
                                            <TextField
                                                name="NomeImpresso"
                                                placeholder='Nome Impresso'
                                                required
                                                autoFocus
                                                onChange={handleChange}
                                                value={criaTokenCartaoCredito && criaTokenCartaoCredito.NomeImpresso ? criaTokenCartaoCredito.NomeImpresso : ''}
                                            />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid size={12}>
                                    <Grid container direction='row'>
                                        <Grid size={6}>
                                            <Typography variant='body1'>
                                                Número Cartão
                                            </Typography>
                                        </Grid>
                                        <Grid size={6}>
                                            {/* <InputMask
                                                mask="9999 9999 9999 9999"
                                                name="NumeroCartao"
                                                placeholder='XXXX XXXX XXXX XXXX'
                                                onChange={handleChange}
                                                value={criaTokenCartaoCredito && criaTokenCartaoCredito.NumeroCartao ? criaTokenCartaoCredito.NumeroCartao : ''}
                                                maskchar="_"
                                            /> */}
                                            <PatternFormat
                                                format="#### #### #### ####"
                                                allowEmptyFormatting
                                                mask="_"
                                                name="NumeroCartao"
                                                placeholder='XXXX XXXX XXXX XXXX'
                                                onChange={handleChange}
                                                value={criaTokenCartaoCredito && criaTokenCartaoCredito.NumeroCartao ? criaTokenCartaoCredito.NumeroCartao : ''}
                                            />



                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid size={12}>
                                    <Grid container direction='row'>
                                        <Grid size={6}>
                                            <Typography variant='body1'>
                                                Data Validade (MM/YYYY)
                                            </Typography>
                                        </Grid>
                                        <Grid size={6}>
                                            {/* <InputMask
                                                mask="99/9999"
                                                name="DataValidade"
                                                placeholder='MM/AAAA'
                                                onChange={handleChange}
                                                value={criaTokenCartaoCredito && criaTokenCartaoCredito.DataValidade ? criaTokenCartaoCredito.DataValidade : ''}
                                                maskchar="_"
                                            /> */}
                                            <PatternFormat
                                                format="##/####"
                                                allowEmptyFormatting
                                                mask="_"
                                                name="DataValidade"
                                                placeholder='MM/AAAA'
                                                onChange={handleChange}
                                                value={criaTokenCartaoCredito && criaTokenCartaoCredito.DataValidade ? criaTokenCartaoCredito.DataValidade : ''}
                                            />


                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid size={12}>
                                    <Grid container direction='row'>
                                        <Grid size={6}>
                                            <Typography variant='body1'>
                                                Código de Segurança
                                            </Typography>
                                        </Grid>
                                        <Grid size={6}>
                                            {/* <InputMask
                                                mask="999"
                                                name="CodigoSeguranca"
                                                placeholder='XXX'
                                                onChange={handleChange}
                                                value={criaTokenCartaoCredito && criaTokenCartaoCredito.CodigoSeguranca ? criaTokenCartaoCredito.CodigoSeguranca : ''}
                                                maskchar="_"
                                            /> */}
                                            <PatternFormat
                                                format="###"
                                                allowEmptyFormatting
                                                mask="_"
                                                name="CodigoSeguranca"
                                                placeholder='XXX'
                                                onChange={handleChange}
                                                value={criaTokenCartaoCredito && criaTokenCartaoCredito.CodigoSeguranca ? criaTokenCartaoCredito.CodigoSeguranca : ''}
                                            />


                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid style={{ marginTop: '30px' }} size={12}>
                                    <Grid container direction='row'>
                                        <Grid size={6}>
                                            <Button
                                                disabled={isLoadingAction}
                                                type='submit'
                                            >
                                                {isLoadingAction && <CircularProgress color="primary" size={20} style={{ marginRight: '10px' }} />}
                                                Cadastrar Cartão
                                            </Button>
                                        </Grid>
                                        <Grid size={6}>

                                        </Grid>
                                    </Grid>

                                </Grid>

                            </Grid>
                        </form>
                    </Grid>
                }

            </Grid>
        </Container>
    );
}

export default UsuarioCartaoCreditoForm;